import Box from '@mui/material/Box'
import { observer } from 'mobx-react-lite'

import { useTheme } from '@mui/material/styles'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { Icon } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../../../common'

const FlagCell = (params: GridRenderCellParams) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === 'dark'

  const { transactions: transactionsCopy } = useGlobalCopyStore()
  const { is_flagged, is_hidden, has_been_viewed, parent_guid } = params.row
  const isChildOfSplit = !!parent_guid
  const hasNotBeenViewed = !has_been_viewed && !isChildOfSplit

  return (
    <Box
      aria-label={is_hidden ? transactionsCopy.is_excluded : transactionsCopy.is_flagged}
      tabIndex={params.tabIndex}
    >
      {is_flagged && (
        <Icon
          fill={true}
          name="flag"
          size={16}
          sx={{ color: isDarkMode ? 'primary.main' : 'warning.dark' }}
        />
      )}
      {!is_flagged && is_hidden && <Icon name="visibility_off" size={16} />}
      {hasNotBeenViewed && (
        <svg
          data-testid="svg"
          style={{
            display: 'inline-block',
            height: 16,
            fill: theme.palette.primary.light,
            verticalAlign: 'middle',
            width: 16,
          }}
          viewBox="0 0 512 512"
        >
          <circle cx="256" cy="256" r="60" />
        </svg>
      )}
    </Box>
  )
}

export default observer(FlagCell)
